import React from 'react'
import Fragment from '../common/fragment'

function FragmentDT(props) {
  return (
    <Fragment pos="tttt" {...props}>
      <p>
      En Salamanca usted puede comprar pequeños nacimientos de colores difusos y
rostros deslumbrados. Entre los animales, encontrará ovejas. Reyes del Oriente.
Sándalo y otras especias. Nabucodonosor, soberanos malditos. Pesebres de
porcelana. Las ovejas se acercan al Niño por la claridad de su rostro. Así se

reconoce a un Dios agazapado, como a Cristo en la oscuridad de la noche. Lo más profundo, nunca deja de brillar.
      </p>
    </Fragment>
  )
}


export default FragmentDT
